import React, { PropsWithChildren, ReactNode } from 'react';
import { ApolloError } from '@apollo/client';
import { Alert, AlertTitle } from '@mui/material';

interface Props {
  isLoading: boolean;
  fallBack?: ReactNode;
  error?: ApolloError | null;
}

export const RenderWithFallback = ({
  children,
  isLoading,
  error = null,
  fallBack = null,
}: PropsWithChildren<Props>) => {
  if (error)
    return (
      <Alert severity="error" variant="outlined">
        <AlertTitle>Something went wrong</AlertTitle>
        {error.message}
      </Alert>
    );

  return <>{isLoading ? fallBack : children}</>;
};
